<ion-app>
    <ion-menu side="end" swipeGesture="false" contentId="main">
      <!-- <ion-header>
        <ion-toolbar>
          <ion-title>Menü</ion-title>
        </ion-toolbar>
      </ion-header> -->
      <ion-content>
        <div class="logo">
          <img src="assets/img/logo.png" />
        </div>
        <ion-list>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
            <ion-item [routerDirection]="'root'" (click)="redirectTo(p)">
              <ion-icon slot="start" [name]="p.icon"></ion-icon>
              <ion-label>
                {{p.title}}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
